module.exports = __webpack_public_path__ + "img/_ABS9803(1).34b71fa4.jpg";